import React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "@shadcn-in-nx/ui/input";
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from "@shadcn-in-nx/ui/select";
import { Search } from "lucide-react";
import { Checkbox } from "@shadcn-in-nx/ui/checkbox";
import { Label } from "@shadcn-in-nx/ui/label";

export default function TicketFilters({
    searchQuery, setSearchQuery, statusFilter, setStatusFilter,
    priorityFilter, setPriorityFilter, tagFilter, setTagFilter,
    showArchived, setShowArchived, availableTags, searchInputRef,
}) {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4">
            <div className="relative w-full sm:flex-1 sm:min-w-[200px] sm:max-w-md">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                <Input
                    ref={searchInputRef}
                    placeholder={t("admin.support.searchPlaceholder", "Search by ID, subject, company... (press / )")}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="pl-10 pr-10"
                />
                <kbd className="absolute right-2 top-1/2 -translate-y-1/2 hidden sm:inline-flex items-center px-1.5 py-0.5 text-[10px] font-mono bg-muted rounded border border-border/60 text-muted-foreground pointer-events-none">/</kbd>
            </div>
            <div className="flex flex-wrap gap-2 sm:gap-4">
                <Select value={statusFilter} onValueChange={setStatusFilter}>
                    <SelectTrigger className="w-[calc(50%-4px)] sm:w-[160px]"><SelectValue placeholder="Status" /></SelectTrigger>
                    <SelectContent>
                        <SelectItem value="all">{t("admin.support.allStatuses", "All Statuses")}</SelectItem>
                        <SelectItem value="OPEN">Open</SelectItem>
                        <SelectItem value="IN_PROGRESS">In Progress</SelectItem>
                        <SelectItem value="WAITING_ON_CUSTOMER">Waiting</SelectItem>
                        <SelectItem value="RESOLVED">Resolved</SelectItem>
                        <SelectItem value="CLOSED">Closed</SelectItem>
                    </SelectContent>
                </Select>
                <Select value={priorityFilter} onValueChange={setPriorityFilter}>
                    <SelectTrigger className="w-[calc(50%-4px)] sm:w-[140px]"><SelectValue placeholder="Priority" /></SelectTrigger>
                    <SelectContent>
                        <SelectItem value="all">{t("admin.support.allPriorities", "All Priorities")}</SelectItem>
                        <SelectItem value="URGENT">Urgent</SelectItem>
                        <SelectItem value="HIGH">High</SelectItem>
                        <SelectItem value="NORMAL">Normal</SelectItem>
                        <SelectItem value="LOW">Low</SelectItem>
                    </SelectContent>
                </Select>
                {availableTags.length > 0 && (
                    <Select value={tagFilter} onValueChange={setTagFilter}>
                        <SelectTrigger className="w-full sm:w-[140px]"><SelectValue placeholder="Tag" /></SelectTrigger>
                        <SelectContent>
                            <SelectItem value="all">{t("admin.support.allTags", "All Tags")}</SelectItem>
                            {availableTags.map((tag) => (<SelectItem key={tag} value={tag}>{tag}</SelectItem>))}
                        </SelectContent>
                    </Select>
                )}
                <div className="flex items-center gap-2">
                    <Checkbox id="show-archived" checked={showArchived} onCheckedChange={setShowArchived} />
                    <Label htmlFor="show-archived" className="text-sm cursor-pointer whitespace-nowrap">
                        {t("admin.support.showArchived", "Show archived")}
                    </Label>
                </div>
            </div>
        </div>
    );
}
